'use client';

import React from 'react';
import { motion } from 'framer-motion';

const GOLD_ACCENT = '#faaf40';
const SHADOW_GOLD = 'rgba(250, 175, 64, 0.6)';

export default function AboutHeroSection() {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
  };

  return (
    <section 
      className="relative flex items-center justify-center h-[70vh] lg:h-[80vh] w-full overflow-hidden bg-black"
    >
      {/* Background Image Container */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/about/aboutbg.webp)',
        }}
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 z-10 bg-black/80" />
      
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={{
          visible: { transition: { staggerChildren: 0.15 } }
        }}
        className="relative z-20 w-full max-w-5xl mx-auto px-6 text-center text-white"
      >
        <motion.h1 
          variants={fadeInUp}
          className="font-extrabold uppercase tracking-tight leading-none"
          style={{ 
            color: GOLD_ACCENT, 
            textShadow: `0 0 15px ${SHADOW_GOLD}` 
          }}
        >
          <span className="block text-4xl sm:text-6xl lg:text-7xl">
            The Aura Principle
          </span>
        </motion.h1>

        <motion.div variants={fadeInUp} className="mt-6 space-y-4">
          <p className="text-base sm:text-xl lg:text-2xl text-white font-medium max-w-3xl mx-auto leading-snug italic">
            "We founded this gym to create an unparalleled sanctuary for those committed to excellence."
          </p>
          
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: 64 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="h-1 bg-[#faaf40] mx-auto rounded-full" 
          />

          <p className="text-sm sm:text-base text-gray-300 max-w-xl mx-auto leading-relaxed">
            Traditional gyms depend on failure. Aura is built on the opposite—one trainer, one client, and one focused 20-minute workout for real results.
          </p>
        </motion.div>

        <motion.button 
          variants={fadeInUp}
          whileHover={{ 
            scale: 1.02, 
            backgroundColor: GOLD_ACCENT, 
            color: '#000',
            boxShadow: `0 0 20px ${SHADOW_GOLD}`,
          }}
          whileTap={{ scale: 0.98 }}
          className="mt-8 px-6 py-3 border-2 text-sm font-bold uppercase tracking-widest transition-all duration-300"
          style={{ 
            borderColor: GOLD_ACCENT, 
            color: GOLD_ACCENT 
          }}
        >
          Explore Sanctuary
        </motion.button>
      </motion.div>
    </section>
  );
}